import axiosApiService from '../axios';

export const askAICopilot = async (
  question,
  conversationHistory = [],
  isSuggested = false
) => {
  try {
    const response = await axiosApiService.post('/chat/ai/', {
      question,
      conversation_history: conversationHistory,
      is_suggested: isSuggested,
    });

    return response.data;
  } catch (error) {
    console.error('AI Copilot API Error:', error);

    // Better error handling
    if (error.response) {
      console.error('Response Error:', error.response.data);

      throw {
        status: error.response.status,
        data: error.response.data,
        message:
          error.response.data?.error ||
          error.response.data?.message ||
          'Server error occurred',
      };
    }

    if (error.request) {
      throw {
        message: 'Backend server is not responding',
      };
    }

    throw {
      message: error.message || 'Something went wrong',
    };
  }
};

export const getCachedAnswer = async (qaId) => {
  try {
    const response = await axiosApiService.get(`/chat/ai/cached-answer/${qaId}/`);

    return response.data;
  } catch (error) {
    console.error('AI Copilot Cached Answer Error:', error);

    if (error.response) {
      throw {
        status: error.response.status,
        data: error.response.data,
        message:
          error.response.data?.error ||
          error.response.data?.message ||
          'Server error occurred',
      };
    }

    if (error.request) {
      throw {
        message: 'Backend server is not responding',
      };
    }

    throw {
      message: error.message || 'Something went wrong',
    };
  }
};